import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import ModulePage from './pages/ModulePage';
import ApiStructurePage from './pages/ApiStructurePage';
import ClientStructurePage from './pages/ClientStructurePage';
import AuthGuidePage from './pages/AuthGuidePage';
import { ApiConfigProvider } from './context/ApiConfigContext';
import './App.css';

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ApiConfigProvider>
      <Router>
        <div className={`app ${theme}`}>
          <Sidebar theme={theme} onToggleTheme={toggleTheme} />
          <main className="main">
            <Routes>
              <Route path="/" element={<Navigate to="/authentication/overview" replace />} />
              <Route path="/guide/structure" element={<ApiStructurePage />} />
              <Route path="/guide/client" element={<ClientStructurePage />} />
              <Route path="/authentication/:submoduleId" element={<AuthGuidePage />} />
              <Route
                path="/:moduleId/:submoduleId"
                element={<ModulePage theme={theme} onToggleTheme={toggleTheme} />}
              />
              <Route path="*" element={<Navigate to="/authentication/overview" replace />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ApiConfigProvider>
  );
}

export default App;
